import { playButtonActionTypes } from './constants';

import type { SongData } from '../types';

export function getSong(id: string | number, word: string, lang: string, shouldHighlight = true) {
	return {
		type: playButtonActionTypes.GET_SONG_REQUEST,
		payload: {
			id,
			word,
			lang,
			shouldHighlight,
		},
	};
}

export function getSongSuccess(id: string | number, song: SongData) {
	return {
		type: playButtonActionTypes.GET_SONG_SUCCESS,
		payload: {
			id,
			song,
		},
	};
}

export function removeSong() {
	return {
		type: playButtonActionTypes.REMOVE_SONG,
		payload: {},
	};
}

export function pauseSong(paused: boolean) {
	return {
		type: playButtonActionTypes.PAUSE_SONG,
		payload: { paused },
	};
}

export function setIsAudioPlaying(isAudioPlaying: boolean, isProcessing = false) {
	return {
		type: playButtonActionTypes.IS_AUDIO_PLAYING,
		payload: { isAudioPlaying, isProcessing },
	};
}

export function setSongId(id: string | number | null) {
	return {
		type: playButtonActionTypes.SET_SONG_ID,
		payload: { id },
	};
}
